import styled, { css } from 'styled-components';

import { StyledPlayerListItemProps } from './StyledPlayerListTypes';

export default styled.div`
  width: 343px;
  height: 884px;
  display: grid;
  grid-template-rows: 2fr 1fr;

  .section {
    overflow-y: auto;

    h1 {
      padding: 15px 0;
    }
  }
`;

export const StyledPlayerListItem = styled.div<StyledPlayerListItemProps>`
  display: grid;
  grid-template-columns: 20px 30px 1fr;
  align-items: center;
  grid-gap: 10px;
  padding: 10px;
  background-color: ${(props) => (props.greyBackground ? props.theme.colors.grey : '#FFFFFF')};
  transition: all 100ms ease-in-out;
  cursor: pointer;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}

  ${(props) =>
    props.isActive &&
    css`
      background-color: ${props.theme.colors.secondary};
    `}

  &:hover {
    background-color: ${(props) => !props.isActive && props.theme.colors.secondaryBright};
  }
`;
